import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Tester } from 'src/app/model/tester';

@Component({
  selector: 'aw-create-tester-dialog',
  templateUrl: './create-tester-dialog.component.html',
  styleUrls: ['./create-tester-dialog.component.scss']
})
export class CreateTesterDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Tester,
    public dialogRef: MatDialogRef<CreateTesterDialogComponent>
  ) {


  }

  ngOnInit(): void {
    console.log(this.data)
  }

}
